const ProjectParticipantRole = {
    MODERATOR: 'Moderator',
    OBSERVER: 'Observer',
    RESPONDENT: 'Respondent'
};

export default ProjectParticipantRole;
